import { useUniversityContext } from '@/context';
import { dormitory } from '@/utils/release';
import { DormitoryPreRegister as DormitoryPreRegisterLegacy } from '@/components/dormitory_legacy';
import { DormitoryPreRegister } from './DormitoryPreRegister';

export function DormitoryPreRegisterGate() {
  const { university } = useUniversityContext();
  if (dormitory.isNewVersion(university)) {
    return <DormitoryPreRegister />;
  }
  return <DormitoryPreRegisterLegacy />;
}
